import React from 'react';
import ReactDOM from 'react-dom';
import domready from 'domready';
import { syncHistoryWithStore } from 'react-router-redux';
import { Router, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import WebFont from 'webfontloader';
import es6promise from 'es6-promise';

import createStore from './store';
import routes from './routes.jsx';

import '../scss/main.global.scss';

es6promise.polyfill();
const store = createStore();

domready(() => {
    const app = document.getElementById('app');
    if (typeof app === 'undefined' || app === null) {
        return;
    }

    function init() {
        const history = syncHistoryWithStore(browserHistory, store);
        const router = React.createElement(Router, {
            history,
            routes,
        });
        const provider = React.createElement(Provider, {
            store,
        }, router);
        ReactDOM.render(provider, app);
    }

    WebFont.load({
        active: init,
        google: {
            families: [
                'Oswald:700',
                'Roboto:400,500,700,900',
            ],
        },
    });
});



// WEBPACK FOOTER //
// ./js/main.js